import {PageLink} from '../../../../../_metronic/layout/core'
import {useIntl} from 'react-intl'
import { toTitleCase } from '../../../../core/_util'

export const StakeholdersBreadCrum: Array<PageLink> = [
  {
    title: 'Home',
    path: '/',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]


export const AddStakeholdersBreadCrum: Array<PageLink> = [
  {
    title: 'Home',
    path: '/',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
  {
    title: 'Shareholders and Investors',
    path: 'stakeholders/stakeholders-and-investors',
    isSeparator: false,
    isActive: true,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]

export const StakeholdersDetailsBreadCrum: Array<PageLink> = [
  {
    title: 'Home',
    path: '/',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
  {
    title: 'Shareholders and Investors',
    path: 'stakeholders/stakeholders-and-investors',
    isSeparator: false,
    isActive: true,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]

export const StakeholdersBreadcrum = () => {
  const {formatMessage} = useIntl()

  const StakeholdersBreadCrum: Array<PageLink> = [
    {
      title: formatMessage({id: 'Home'}),
      path: '/',
      isSeparator: false,
      isActive: false,
    },
    {
      title: '',
      path: '',
      isSeparator: true,
      isActive: false,
    },
  ]

  const AddStakeholdersBreadCrum: Array<PageLink> = [
    {
      title: formatMessage({id: 'Home'}),
      path: '/',
      isSeparator: false,
      isActive: false,
    },
    {
      title: '',
      path: '',
      isSeparator: true,
      isActive: false,
    },
    {
      title: formatMessage({id: 'Shareholders and investors'}),
      path: 'stakeholders/stakeholders-and-investors',
      isSeparator: false,
      isActive: true,
    },
    {
      title: '',
      path: '',
      isSeparator: true,
      isActive: false,
    },
  ]

  const StakeholdersDetailsBreadCrum: Array<PageLink> = [
    {
      title: formatMessage({id: 'Home'}),
      path: '/',
      isSeparator: false,
      isActive: false,
    },
    {
      title: '',
      path: '',
      isSeparator: true,
      isActive: false,
    },
    {
      title: formatMessage({id: 'Shareholders'}),
      path: 'stakeholders/stakeholders-and-investors',
      isSeparator: false,
      isActive: true,
    },
    {
      title: '',
      path: '',
      isSeparator: true,
      isActive: false,
    },
  ]

  

  return {
    StakeholdersBreadCrum,
    AddStakeholdersBreadCrum,
    StakeholdersDetailsBreadCrum,
  }
}

export enum ShareholdersTypes {
  INDIVIDUAL = "individual",
  INSTITUTIONAL = "institution",
}

export enum stakeholderCategory {
  INVESTOR_SHAREHOLDER = "Investor Shareholder",
  PROMOTER_SHAREHOLDER = "Promoter Shareholder",
  OTHER_SHAREHOLDER = "Other Shareholder",
}

export const shareholdersCategoryOptions = [
  {id: 1, value: stakeholderCategory.INVESTOR_SHAREHOLDER, label: stakeholderCategory.INVESTOR_SHAREHOLDER},
  {id: 2, value: stakeholderCategory.PROMOTER_SHAREHOLDER, label: stakeholderCategory.PROMOTER_SHAREHOLDER},
  {id: 3, value: stakeholderCategory.OTHER_SHAREHOLDER, label: stakeholderCategory.OTHER_SHAREHOLDER},
]

export const institutionBestContactOptions = [
  {id: 1, value: 'Email', label: 'Email'},
  {id: 2, value: 'Phone', label: 'Phone'},
  {id: 3, value: 'LinkedIn', label: 'LinkedIn'},
  {id: 4, value: 'Whatsapp', label: 'Whatsapp'},
  {id: 6, value: 'Telegram', label: 'Telegram'},
  {id: 5, value: 'Discord', label: 'Discord'},


]

export const seniorityOptions = [
  {id: 1, value: 'Level1', label: 'Level 1'},
  {id: 2, value: 'Level2', label: 'Level 2'},
  {id: 3, value: 'Level3', label: 'Level 3'},
  {id: 4, value: 'Level4', label: 'Level 4'},
  {id: 5, value: 'Level5', label: 'Level 5'},
]

export const participatingOptions = [
  {id: 1, value: 'yes', label: 'Yes'},
  {id: 2, value: 'no', label: 'No'},
]

export enum ConveresionParameters {
  CONVERSION_RATIO = "conversionRatio",
  CONVERSION_PRICE = "conversionPrice",
}

export const conversionParametersOptions = [
  {id: 1, value: ConveresionParameters.CONVERSION_RATIO, label: 'Conversion Ratio'},
  {id: 2, value: ConveresionParameters.CONVERSION_PRICE, label: 'Conversion Price'},
]

export enum ConvertibleTypes {
  SAFE = "safe",
  KISS = "kiss",
  CUSTOM = "custom",
  
}

export const convertibleTypesOptions = [
  {id: 1, value: ConvertibleTypes.SAFE , label: ConvertibleTypes.SAFE.toUpperCase()},
  {id: 2, value: ConvertibleTypes.KISS, label: ConvertibleTypes.KISS.toUpperCase()},
  {id: 3, value: ConvertibleTypes.CUSTOM, label: ConvertibleTypes.CUSTOM.toUpperCase()},
]

export enum ValuationCap {
  PRICE = "Price",
  VALUATION = "Valuation",
}

export const valuationCapOptions = [
  {id: 1, value: ValuationCap.PRICE.toLowerCase(), label: ValuationCap.PRICE},
  {id: 2, value: ValuationCap.VALUATION.toLowerCase(), label: ValuationCap.VALUATION},
]

export enum AccuralPeriod {
  DAILY = "daily",
  WEEKLY = "weekly",
  MONTHLY = "monthly",
  ANNUALLY = "annually",
}

export const accuralPeriodOptions = [
  {id: 1, value: AccuralPeriod.DAILY, label: toTitleCase(AccuralPeriod.DAILY)},
  {id: 2, value: AccuralPeriod.WEEKLY, label: toTitleCase(AccuralPeriod.WEEKLY)},
  {id: 3, value: AccuralPeriod.MONTHLY, label: toTitleCase(AccuralPeriod.MONTHLY)},
  {id: 4, value: AccuralPeriod.ANNUALLY, label: toTitleCase(AccuralPeriod.ANNUALLY)},
]

export enum CompoundingMethod {
  SIMPLE = "simple",
  COMPOUND = "compound",
}

export const compoundingMethodOptions = [
  {id: 1, value: CompoundingMethod.SIMPLE, label: toTitleCase(CompoundingMethod.SIMPLE)},
  {id: 2, value: CompoundingMethod.COMPOUND, label: toTitleCase(CompoundingMethod.COMPOUND)},
]

export const ComplianceAttendanceType = [
  {
    id: 1,
    label: 'Unknown',
    value: 'unknown',
  },
  {
    id: 2,
    label: 'Invited',
    value: 'invited',
  },
  {
    id: 3,
    label: 'Present',
    value: 'present',
  },
  {
    id: 4,
    label: 'Absent',
    value: 'absent',
  },
  {
    id: 5,
    label: 'Accept',
    value: 'accept',
  },
  {
    id: 6,
    label: 'Reject',
    value: 'reject',
  },
]

export const founderPromoterSidebarFields: { [key in 1 | 2 | 3 ]: string[] } = {
  1: ['firstName', 'lastName', 'email', 'phone', 'phoneCode', 'gender', 'dateOfBirth','guardianName','guardianPhoneCode','guardianPhoneNumber','guardianEmail','guardianRelationship'],
  2: ['address1', 'address2', 'country', 'state', 'city', 'zipCode'],
  3: ['designation', 'nationality', 'govtIssuedIdType', 'govtIssuedIdNumber', 'website', 'education', 'skills', 'fundraisingRoundExecuted', 'totalCapitalRaised','professionalExperiences'],
};

export const boardMemberSidebarFields: { [key in 1 | 2 | 3 ]: string[] } = {
  1: ['firstName', 'lastName', 'email', 'phone', 'phoneCode', 'gender', 'dateOfBirth','workCompanyName', 'workIndustry', 'workExperience', 'boardTaskPreferences'],
  2:['address1', 'address2', 'country', 'state', 'city', 'zipCode'],
  3: ['designation', 'nationality', 'govtIssuedIdType', 'govtIssuedIdNumber', 'website', 'education', 'skills','otherAffiliations'],
};


export const managementTeamSidebarFields: { [key in 1 | 2 | 3 ]: string[] } = {
  1: ['firstName', 'lastName', 'email', 'phone', 'phoneCode', 'gender', 'dateOfBirth','workCompanyName', 'workIndustry'],
  2:['address1', 'address2', 'country', 'state', 'city', 'zipCode'],
  3: ['designation', 'nationality', 'govtIssuedIdType', 'govtIssuedIdNumber', 'website','title', 'skills'],
};

export const shareholderSidebarFields: { [key in 1 | 2 | 3  ]: string[] } = {
  1: ['firstName', 'lastName', 'email', 'phone','phoneCode',  'dateOfBirth','workCompanyName', 'stakeholderCategory','commencementDate','separationDate','reasonForSeparation'],
  2:['address1', 'address2', 'country', 'state', 'city', 'zipCode'],
  3: ['designation','employeeId', 'nationality','presentCountry', 'govtIssuedIdType', 'govtIssuedIdNumber', 'website','referredBy','exCompanies','lastHeardDate','guardianName','guardianRelationship','guardianEmail','guardianPhoneNumber'],
};

export const shareholderInstitutionSidebarFields: { [key in 1 | 2 | 3  ]: string[] } = {
  1: ['stakeholderCategory','legalName','govtIssuedIdType','govtIssuedIdNumber','domicile','firstName', 'lastName', 'email', 'phone','phoneCode', 'designation','nationality'],
  2:['address1', 'address2', 'country', 'state', 'city', 'zipCode','institutionAddress1', 'institutionAddress2', 'institutionCountry', 'institutionState', 'institutionCity', 'institutionZipCode'],
  3: [ 'website','referredBy','lastHeardDate','institutionBestContactChannel'],
};

export enum BuybackMethods{
  FIFO = 'fifo',
  LIFO = 'lifo',
  MANUAL = 'manual'
}

export const buybackMethodOptions = [
  {id: 1, value: BuybackMethods.FIFO, label: 'FIFO (First In, First Out)'},
  {id: 2, value: BuybackMethods.LIFO, label: 'LIFO (Last In, First Out)'},
  {id: 3, value: BuybackMethods.MANUAL, label: 'Manual Selection'},
]

export enum TransactionModals {
  NONE = 'none',
  ADD_SHARES_TRANSACTION = 'AddSharesTransaction',
  ADD_CONVERTIBLE_TRANSACTION = 'AddConvertibleTransaction',
  ADD_WARRANT_TRANSACTION = 'AddWarrantTransaction',
  ADD_BUYBACK_TRANSACTION = 'AddBuybackTransaction',
  ADD_TRANSFERRED_TRANSACTION = 'AddTransferredTransaction',
  SHARE_TRANSACTION_DETAILS = 'ShareTransactionDetails',
  CONVERTIBLE_TRANSACTION_DETAILS = 'ConvertibleTransactionDetails',
  WARRANT_TRANSACTION_DETAILS = 'WarrantTransactionDetails',
  BUYBACK_TRANSACTION_DETAILS = 'BuybackTransactionDetails',
  TRANSFERRED_TRANSACTION_DETAILS = 'TransferredTransactionDetails',
  SECURITY_CLASS_MODAL = 'SecurityClassModal',
  CONVERTIBLE_CLASS_MODAL = 'ConvertibleClassModal',
  WARRANT_CLASS_MODAL = 'WarrantClassModal',
  ADD_SECURITY_CLASS_MODAL = 'AddSecurityClassModal',
  ADD_CONVERTIBLE_CLASS_MODAL = 'AddConvertibleClassModal',
  ADD_WARRANT_CLASS_MODAL = 'AddWarrantClassModal', 
}
 
